import { animate, AnimationBuilder, AnimationPlayer, keyframes, style } from '@angular/animations';
import { ChangeDetectorRef, Directive, ElementRef, Input, OnInit, Self } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Actions, ofType } from '@ngrx/effects';
import { filter, takeUntil } from 'rxjs/operators';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { createAction, props } from '@ngrx/store';

/**
 * ngrx action to scroll and open a field
 * accordian by the field accordian id.
 *
 */
export const SCROLL_AND_OPEN_ACCORDIAN = createAction(
  '[Accordian Expansion Directive] SCROLL_AND_OPEN_ACCORDIAN',
  props<{ id: string }>()
);

/**
 * Scrolls, animates and expands an accordian for a given ID
 * listens for SCROLL_AND_OPEN_ACCORDIAN action.
 *
 * Usage:
 *     <mat-expansion-panel class="ab-list-item"
 *           [appExpansionListenForId]="'100'"
 *
 * To trigger expansion dispatch event
 *      this._store.dispatch(
 *           SCROLL_AND_OPEN_ACCORDIAN({ id: "100"})
 *         );
 */
@Directive({
  selector: '[appExpansionListenForId]'
})
export class AccordianExpansionDirective extends WithDisposableSubject() implements OnInit {
  @Input('appExpansionListenForId') id: string;

  animation: AnimationPlayer;
  /**
   *
   */

  constructor(
    @Self() public expansionPanel: MatExpansionPanel,
    private el: ElementRef,
    private _cd: ChangeDetectorRef,
    private animationBuilder: AnimationBuilder,
    private actions$: Actions
  ) {
    super();
  }

  ngOnInit() {
    this.actions$.pipe(
      takeUntil(this.disposer),
      ofType(SCROLL_AND_OPEN_ACCORDIAN),
      filter(a => a.id === this.id)
    ).subscribe(() => this.focusAndOpen());

    // Some keyframes to do some color changes so it is clear that item
    // was pulled into view
    this.animation = this.animationBuilder.build([
      animate(1500, keyframes([
        style({ backgroundColor: 'rgba(149, 160, 171, 0.5)' }),
        style({ backgroundColor: 'rgba(149, 160, 171, 0.2)' }),
        style({ backgroundColor: 'rgba(149, 160, 171, 0.5)' }),
        style({ backgroundColor: 'white' })
      ])
      )
    ]).create(this.el.nativeElement);
  }

  focusAndOpen() {
    setTimeout(() => this.el.nativeElement?.scrollIntoView({ behavior: 'smooth' }), 50);
    this.expansionPanel?.open();
    this.animation?.play();
    this._cd.markForCheck();
  }
}
